module.exports = __webpack_public_path__ + "img/Luna2.8ff68455.8ff68455.png";